/* ========================================================= * Material Kit 2 PRO React - v2.0.0 ========================================================= * Product Page: https://www.creative-tim.com/product/material-kit-pro-react * Copyright 2021 Creative Tim (https://www.creative-tim.com) Coded by www.creative-tim.com ========================================================= * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. */


// react
import { useRef } from "react";

// next
import dynamic from "next/dynamic";

// MUI
const Grid = dynamic(() => import("@mui/material/Grid"), { loading: () => null });

// PRO
const MDTypography = dynamic(() => import('/components/MDTypography'), { loading: () => null });

// Parts
const ALLDVideo = dynamic(() => import('/examples/ALLDVideo'), { loading: () => null });

function ALLDVideoReviews({ videoReviews, showReviewerName }) {
  return (
    <>
      <Grid container spacing={6}>
        {videoReviews.map((row, index) => {
          const boxRef = useRef();
          const imageRef = useRef();
          return (
            <Grid item xs={12} sm={6} key={`video-${index}`}>
              <ALLDVideo row={row} />
              {showReviewerName === true && (
                <MDTypography variant="body2" fontWeight="regular">
                  {row.title}
                </MDTypography>
              )}
            </Grid>
          );
        })}
      </Grid>
      <br />
      <br />
    </>
  );
}

export default ALLDVideoReviews;

